/**
 * @generated SignedSource<<5fe6c2e179c4b5823712efae74527f95>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConditionalFormattingSidebarContainer_project$data = {
  readonly key: string;
  readonly " $fragmentType": "ConditionalFormattingSidebarContainer_project";
};
export type ConditionalFormattingSidebarContainer_project$key = {
  readonly " $data"?: ConditionalFormattingSidebarContainer_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConditionalFormattingSidebarContainer_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ConditionalFormattingSidebarContainer_project",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "f760c50423ac93ea44e63273b01a0d10";

export default node;
